import { Routes } from "@angular/router";

import { afterLoginGuard } from "./common/guards/after-login/after-login.guard";
import { beforeLoginGuard } from "./common/guards/before-login/before-login.guard";

import { ngxPermissionsGuard } from "ngx-permissions";
import { ModulesPerms } from "./common/interfaces/menu.interface";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "login",
    loadComponent: () => import("./guests/login/login").then((m) => m.Login),
    canActivate: [beforeLoginGuard],
  },

  {
    path: "activate",
    loadComponent: () =>
      import("./guests/activation-reset/activation-reset").then(
        (m) => m.ActivationReset
      ),
    canActivate: [beforeLoginGuard],
    data: {
      forActivation: true,
    },
  },
  {
    path: "reset-password",
    loadComponent: () =>
      import("./guests/activation-reset/activation-reset").then(
        (m) => m.ActivationReset
      ),
    canActivate: [beforeLoginGuard],
    data: {
      forActivation: false,
    },
  },
  {
    path: "home",
    canActivate: [afterLoginGuard],
    loadChildren: () =>
      import("./modules/home/home.routes").then((m) => m.HOME_ROUTES),
  },

  {
    path: "**",
    redirectTo: "login",
  },
];
